import { Alert, Button, PageHeader } from "@emdur/ui";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { completeSignIn, startSignIn } from "../lib/auth";
import { errorText } from "../lib/errors";

export function SignIn() {
  const [error, setError] = useState<unknown>(null);
  const { hash } = useLocation();
  const session = new URLSearchParams(hash.slice(1)).get("session");
  const [notice] = useState(() => sessionStorage.getItem("emdur.signout"));
  useEffect(() => {
    sessionStorage.removeItem("emdur.signout");
    if (session) {
      setError(null);
      completeSignIn(session).catch(setError);
    }
  }, [session]);
  return (
    <div className="flex flex-col gap-4">
      <PageHeader
        title="Sign in"
        description="Use your passkey to manage your organisations."
      />
      {notice && <Alert tone="warning">{notice}</Alert>}
      {error !== null && (
        <Alert tone="danger">
          {errorText(error)}
          <p>Start again with your passkey.</p>
        </Alert>
      )}
      {session && !error ? (
        <p>Waiting for your passkey…</p>
      ) : (
        <Button
          variant="primary"
          onPress={() => void startSignIn().catch(setError)}
        >
          Sign in with a passkey
        </Button>
      )}
    </div>
  );
}
